import { createFileRoute } from "@tanstack/react-router";
import { SyndicateAdmin } from "@/components/Syndicates/Admin";
import BackButton from "@/components/GoBack";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const syndicateId = params?.id as string;

  return (
    <>
      <BackButton />
      <SyndicateAdmin syndicateId={syndicateId} />
    </>
  );
}

export const Route = createFileRoute("/_authenticated/syndicates/$id/admin/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
